<template>
  <div>
    <section class="section-ac-cleaning">
      <div class="row">
        <div class="col-lg-6 offset-lg-3">
          <request-form :serviceId="16" />
        </div>
      </div>
    </section>

    <section id="header">
      <div class="container">
        <div class="row">

          <div class="col-12 offset-md-7 col-md-5 text-center align-self-end">
            <div class="box-right" data-aos="fade-left">
              <span class="title-header">บริการล้างแอร์</span>
              <h5>“ให้บริการมาตรฐานสูง ด้วยช่างมืออาชีพ”</h5>
            </div>
          </div>

        </div>
      </div>

      <img src="/static/img/acCleaning/man-header.png"
           data-aos="fade-up"
           class="man d-none d-md-block" alt="">
    </section>

    <section id="our-service">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-8">
            <h2 class="text-center" data-aos="fade-up">บริการของเรา</h2>
            <p class="text-center" data-aos="fade-up">
              บริการล้างแอร์บ้านมาตรฐานสูง เพื่อให้คุณได้รับอากาศบริสุทธิ์<br>
              สะอาดหมดจด ปราศจากเชื้อโรค และช่วยให้้ประหยัดค่าไฟมากขึ้น<br>
              ตรวจเช็คระดับความเย็น ตรวจวัดน้ำยาแอร์ และการทำงานของคอมเพรสเซอร์
            </p>
          </div>

        </div>
      </div>

    </section>

    <section id="contact-us">
      <div class="container-fluid no-gutters p-0">
        <div class="row no-gutters">
          <div class="col-12 col-md-4">

            <div class="box-left">
              <h2 data-aos="fade-right">CONTACT</h2>
              <h3 data-aos="fade-right">ติดต่อใช้บริการ</h3>
              <img data-aos="fade-up" src="/static/img/acCleaning/remote.png" class="d-none d-md-block"
                   alt="contact-us">
            </div>

          </div>
          <div class="col-12 col-md-8 col-right">
            <div class="box-right">
              <p class="text-center" data-aos="fade-up">สำหรับการจองใช้บริการ หรือสอบถามข้อมูลเพิ่มเติม<br>กรุณาคลิกที่ปุ่มด้านล่าง
                เพื่อนัดหมายการใช้บริการ</p>
              <p class="text-center" data-aos="fade-up">หรือ โทร <span class="tel">
                <a href="tel:+6621131138">02-113-1138</a>,
                <a href="tel:+66927572999">092-757-2999</a></span>
                เพื่อติดต่อฝ่ายบริการของเรา</p>
              <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank" class="btn" data-aos="fade-up">จองเลย</a>
            </div>
          </div>
        </div>

      </div>

    </section>

    <section id="type-air">
      <div class="container">
        <div class="row">
          <div data-aos="fade-right" class="col-12 col-md-5 text-center align-self-center order-md-1 order-2">
            <img src="/static/img/acCleaning/Air1.png" class="img-fluid"><br>
            <span>น้อยกว่า 24,000 BTU</span>
          </div>
          <div data-aos="fade-up" class="col-12 col-md-2 align-self-center order-md-2 order-1">
            <h2 class="text-center">แบบติดผนัง</h2>
          </div>
          <div data-aos="fade-left" class="col-12 col-md-5 text-center order-md-3 order-3">
            <img src="/static/img/acCleaning/Air2.png" class="img-fluid" style="height: 117px">
            <span>มากกว่า 24,000 BTU</span>
          </div>
        </div>


        <div class="row">
          <div data-aos="fade-right" class="col-12 col-md-5 text-center align-self-center order-md-1 order-2">
            <img src="/static/img/acCleaning/Air3.png" class="img-fluid" width="350"><br>
            <span>น้อยกว่า 24,000 BTU</span>
          </div>
          <div data-aos="fade-up" class="col-12 col-md-2 align-self-center order-md-2 order-1">
            <h2 class="text-center">แบบแขวน</h2>
          </div>
          <div data-aos="fade-left" class="col-12 col-md-5 text-center order-md-3 order-3">
            <img src="/static/img/acCleaning/Air4.png" class="img-fluid" width="350">
            <span>มากกว่า 24,000 BTU</span>
          </div>
        </div>


      </div>

    </section>

    <section id="cost-service">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="text-center" data-aos="fade-up">อัตราค่าบริการ</h2>

            <div class="table-responsive">
              <table class="table table-bordered text-center">
                <thead>
                <tr data-aos="fade-up">
                  <th>ประเภท Type</th>
                  <th>ขนาด BTU</th>
                  <th>ค่าบริการก่อน Vat</th>
                  <th>รวมค่าบริการ</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td class="title" rowspan="2" style="background:#93addb;font-weight: 500;padding:30px;">แบบติดผนัง
                    <br> (Wall Type)
                  </td>
                  <td style="background: #cfd5eb;">ไม่เกิน 24,000 BTU</td>
                  <td style="background: #cfd5eb;">590 บาท</td>
                  <td data-aos="zoom-in" style="background: #cfd5eb;color:red;font-weight: 500;">631 บาท</td>
                </tr>
                <tr>
                  <td style="background: #93addb;">มากกว่า 24,000 BTU</td>
                  <td style="background: #93addb;">750 บาท</td>
                  <td data-aos="zoom-in" style="background: #93addb;color:red;font-weight: 500;">803 บาท</td>
                </tr>

                <tr>
                  <td class="title" rowspan="2" style="background: #7693c7;font-weight: 500;padding:30px;">แบบแขวน <br>
                    (Ceiling type)
                  </td>
                  <td style="background: #cfd5eb;">ไม่เกิน 24,000 BTU</td>
                  <td style="background: #cfd5eb;">990 บาท</td>
                  <td data-aos="zoom-in" style="background: #cfd5eb;color:red;font-weight: 500;">1,059 บาท</td>
                </tr>
                <tr>
                  <td style="background: #93addb;">มากกว่า 24,000 BTU</td>
                  <td style="background: #93addb;">1,200 บาท</td>
                  <td data-aos="zoom-in" style="background: #93addb;color:red;font-weight: 500;">1,284 บาท</td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="condition">
              <p class="m-0" data-aos="fade-up">เงื่อนไขการให้บริการ</p>
              <ul class="list-condition">
                <li data-aos="fade-up">พิกัดการเข้าให้บริการ (เกินจากนี้ คิดค่าเดินทางเพิ่ม กิโลเมตรละ 6 บาท)</li>
                <li data-aos="fade-up">เชียงใหม่ : รัศมี 30 กิโลเมตร จาก อ.เมือง จ.เชียงใหม่</li>
              </ul>

            </div>
          </div>
        </div>
      </div>
    </section>


    <section id="contact-footer">
      <div class="container-fluid no-gutters p-0">
        <div class="row justify-content-center no-gutters pb-5 pb-md-0 pt-5 pt-md-0">

          <div class="col-12 col-md-3 align-self-center text-center box-left">
            <h1 data-aos="fade-right">CONTACT</h1>
            <h3 data-aos="fade-right">ติดต่อใช้บริการ</h3>


          </div>

          <div class="align-self-center col-12 col-md-2 mb-5 mb-md-0 mt-4 mt-md-0 text-center">
            <a data-aos="fade-up" href="https://line.me/R/ti/p/%40hnk7011n" target="_blank" class="btn">จองเลย</a>
          </div>

          <div data-aos="fade-left" class="col-12 col-md-4 align-self-center box-right">
            <p>คลิกที่ปุ่ม เพื่อนัดหมายการใช้บริการ</p>
            <p class="mb-0">หรือ โทร <a href="tel:+6621131138">02-113-1138</a>,
              <a href="tel:+66927572999">092-757-2999</a> เพื่อติดต่อฝ่ายบริการของเรา</p>
          </div>

        </div>
      </div>
    </section>

  </div>
</template>

<script>
  import RequestForm from '../serviceRequest/RequestForm'
  import AOS from 'aos'

  export default {
    name: 'AcCleaning',
    components: {
      RequestForm
    },
    created () {
      AOS.init({
        once: true,
        disabled: 'mobile',
        duration: 1000
      })
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../static/sass/page/ac_cleaning.scss";
  @import "~aos/dist/aos.css";
</style>



// WEBPACK FOOTER //
// src/components/information/AcCleaning.vue